const actions = {
  SET_STATE: 'staffs/SET_STATE',
  GET_STAFFS: 'staffs/GET_STAFFS',
  GET_STAFF_DROPDOWNS: 'staffs/GET_STAFF_DROPDOWNS',
  GET_STAFF_PROFILE: 'staffs/GET_STAFF_PROFILE',
  CREATE_STAFF: 'staffs/CREATE_STAFF',
  APPEND_STAFFS_LIST: 'staffs/APPEND_STAFFS_LIST',
  EDIT_STAFF: 'staffs/EDIT_STAFF',
  UPDATE_STAFFS_LIST: 'staffs/UPDATE_STAFFS_LIST',
  STAFF_ACTIVE_INACTIVE: 'staffs/STAFF_ACTIVE_INACTIVE',
  UPDATE_STAFF_INFO: 'staffs/UPDATE_STAFF_INFO',
  UPDATE_STAFF_ACTIVE_INACTIVE: 'staffs/UPDATE_STAFF_ACTIVE_INACTIVE',
  PAGE_CHANGED: 'staffs/PAGE_CHANGED',
}

export default actions
